/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {PhoneNumberLookupService} from '../../generated/iam-client';
import {Country} from '../../model/country';
import {from, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {iamApiPerformPhoneNumberLookupUnexpectedError, iamApiPhoneNumberLookupPerformed} from './actions';
import {AnyAction} from 'redux';

class PhoneNumberLookupResource {

	phoneNumberLookup(country: Country, phoneNumber: string): Observable<AnyAction> {
		const promise = PhoneNumberLookupService.phoneNumberLookup(country, phoneNumber);

		return from(promise)
			.pipe(
				map((responseBody) => iamApiPhoneNumberLookupPerformed({result: responseBody})),
				catchError(() => of(iamApiPerformPhoneNumberLookupUnexpectedError()))
			);
	}
}

export default PhoneNumberLookupResource;
